<div class="page-main-header" style="margin-left: 0px; width:100%;" [class.open]="open">
  <div class="main-header-right row" style="padding-left: 0px;">
    <div class="nav-right col">
      <ul class="nav-menus" [ngClass]="{'open' : openNav}">
        <div style="float: left;
             width: 100%;
             text-align: left;" class="row">
          <div class="col-md-auto align-items-center">
            <img class="blur-up lazyloaded"
              style="vertical-align: super; padding: 0px; display: flex; align-items: center;"
              src="../../../../assets/images/anre-logo-icon.png" alt="" [routerLink]="'/'">
          </div>
          <div class="col align-items-center">
            <div class="col-xl-9">
              <h1 class="bold" style="font-size: 20px;">{{title}}</h1>
            </div>
          </div>
          <div class="col-md-auto align-items-center navBarFloatRight">
            <h1 class="bold" style="font-size: 14px;"><a (click)="onPageChange('acasa')">{{home}}</a></h1>
          </div>
          <div class="col-md-auto align-items-center navBarFloatRight">
            <h1 class="bold" style="font-size: 14px;"><a (click)="onPageChange('despre')">{{about}}</a></h1>
          </div>
          <div class="col-md-auto align-items-center navBarFloatRight">
            <li style="width: auto;" class="onhover-dropdown">
              <h1 class="bold" style="font-size: 14px;"><a>{{comparators}}</a></h1>
              <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                <li>
                  <a target="_blank" aria-expanded="false" [routerLink]="['/comparator']"
                    [queryParams]="{comparatorType: 'electric'}">
                    {{offerComparisonElectricity}}
                  </a>
                </li>
                <li>
                  <a target="_blank" aria-expanded="false" [routerLink]="['/comparator']"
                    [queryParams]="{comparatorType: 'gas'}">
                    {{offerComparisonGas}}
                  </a>
                </li>
              </ul>
            </li>
          </div>
          <div class="col-md-auto align-items-center navBarFloatRight">
            <li style="width: auto;" class="onhover-dropdown">
              <h1 class="bold" style="font-size: 14px;"><a>{{manual}}</a></h1>
              <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                <!-- TODO: check if this needs to be removed -->
                <!--<li><a target="_blank" href="../../../../assets/pdf/POSF.ANRE - Manual de utilizare_ANRE.docx">
                    Manual de utilizare ANRE
                  </a></li>-->
                <!--<li><a target="_blank" href="../../../../assets/pdf/POSF.ANRE - Manual de utilizare_CF.docx">
                    Manual de utilizare client final
                  </a></li>-->
                <li><a target="_blank" href="../../../../assets/pdf/POSF.ANRE - Manual de utilizare_Furnizor.docx">
                    Manual de utilizare furnizor
                  </a></li>
                <li><a target="_blank" href="../../../../assets/pdf/POSF.ANRE - Manual de utilizare_Operator.docx">
                    Manual de utilizare operator
                  </a></li>
              </ul>
            </li>
          </div>
          <div class="col-md-auto align-items-center navBarFloatRight">
            <h1 class="bold" style="font-size: 14px;"><a (click)="onPageChange('contact')">{{contact}}</a></h1>
          </div>
          <div class="col-md-auto align-items-center navBarFloatRight">
            <li>
              <a href="javascript:void(0)" class="text-dark" toggleFullscreen>
                <app-public-feather-icons [icon]="'maximize-2'"></app-public-feather-icons>
              </a>
            </li>
            <li class="onhover-dropdown">
              <div class="media align-items-center">
                <img class="align-self-center pull-right img-50 rounded-circle" src="/assets/images/man.png"
                  alt="header-user">
              </div>
              <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                <li><a (click)="login()">
                    <app-public-feather-icons [icon]="'log-in'"></app-public-feather-icons>
                    Autentificare
                  </a></li>
                <li><a [routerLink]="'/inregistrare'">
                    <app-public-feather-icons [icon]="'book'"></app-public-feather-icons>
                    Inregistrare
                  </a></li>
              </ul>
            </li>
          </div>
        </div>
      </ul>
      <div class="d-lg-none mobile-toggle pull-right" (click)="openMobileNav()">
        <app-public-feather-icons [icon]="'more-horizontal'"></app-public-feather-icons>
      </div>
    </div>
  </div>
</div>
